<template>
  <!-- 众包发票管理 -> 开票订单详情 -> 任务信息 -->
  <div class="base-card-info">
    <div class="info-card-title">
      任务信息
    </div>

    <div class="custom-base-info">
      <!-- 任务名称 -->
      <div class="item">
        <div class="label">
          任务名称
        </div>
        <div class="value">
          {{ duty.dutyName || '--' }}
        </div>
      </div>
      <!-- 订单编号 -->
      <div class="item">
        <div class="label">
          订单编号
        </div>
        <div class="value">
          {{ duty.orderNo || '--' }}
        </div>
      </div>
      <!-- 订单状态 -->
      <div class="item">
        <div class="label">
          订单状态
        </div>
        <div class="value">
          <custom-tag
            v-if="!isNull(duty.orderStatus)"
            class="!justify-start"
            :type="orderStatus"
            :label="settlementStatusLabel[duty.orderStatus]"
          />
          <span v-else>
            --
          </span>
        </div>
      </div>
      <!-- 任务类型 -->
      <div class="item">
        <div class="label">
          任务类型
        </div>
        <div class="value">
          {{ duty.dutyTempName || '--' }}
        </div>
      </div>
      <!-- 订单开始时间 -->
      <div class="item">
        <div class="label">
          订单开始时间
        </div>
        <div class="value">
          {{ duty.startTime || '--' }}
        </div>
      </div>
      <!-- 订单结束时间 -->
      <div class="item">
        <div class="label">
          订单结束时间
        </div>
        <div class="value">
          {{ duty.endTime || '--' }}
        </div>
      </div>
      <!-- 企业名称 -->
      <div class="item">
        <div class="label">
          企业名称
        </div>
        <div class="value">
          {{ duty.companyName || '--' }}
        </div>
      </div>
      <!-- 发票科目 -->
      <div class="item">
        <div class="label">
          {{ info?.taxSourceType === ETaxSourceType.Mainland ? '发票科目' : '订单发票' }}
        </div>
        <div class="value">
          {{ duty.invoiceSubName || '--' }}
        </div>
      </div>
      <!-- 支付通道 -->
      <div class="item">
        <div class="label">
          支付通道
        </div>
        <div class="value">
          {{ paymentChannelLabel[duty.payType] || '--' }}
        </div>
      </div>
      <!-- 收入性质 -->
      <div v-if="!isHnFreePartners" class="item">
        <div class="label">
          收入性质
        </div>
        <div class="value">
          {{ proxyPayTypeConfig[duty.proxyPayType] || '--' }}
        </div>
      </div>
      <!-- 开票方式 -->
      <div class="item">
        <div class="label">
          开票方式
        </div>
        <div class="value">
          {{ invoiceTaxMethodConfig[duty?.invoiceTaxMethod] || '--' }}
        </div>
      </div>
      <!-- 服务主体 -->
      <div class="item">
        <div class="label">
          服务主体
        </div>
        <div class="value">
          {{ duty.serverName || '--' }}
        </div>
      </div>
      <!-- 任务合同 -->
      <div class="item">
        <div class="label">
          任务合同
        </div>
        <div class="value">
          <el-link v-if="duty.contractUrl" type="primary" :underline="false" @click="openLinkFile(duty.contractUrl)">
            {{ duty.contractName || '--' }}
          </el-link>

          <span v-else>
            --
          </span>
        </div>
      </div>
      <!-- 订单合同 -->
      <div class="item">
        <div class="label">
          订单合同
        </div>
        <div class="value">
          <el-button v-if="info.contractUrl" link @click="openLinkFile(info.contractUrl)">
            {{ info.contractName || '--' }}
          </el-button>
          <span v-else>
            --
          </span>
        </div>
      </div>
      <div class="item">
        <div class="label">
          &nbsp;
        </div>
        <div class="value">
          &nbsp;
        </div>
      </div>
      <div v-if="isHnFreePartners" class="item">
        <div class="label">
          &nbsp;
        </div>
        <div class="value">
          &nbsp;
        </div>
      </div>
    </div>

    <div class="custom-base-info pt-3">
      <!-- 结算说明 -->
      <div class="item">
        <div class="label">
          结算说明
        </div>
        <div class="value !max-w-[760px]">
          {{ duty.remark || '--' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { isNull } from '@core/tools';
import { ElMessage } from 'element-plus';
import { CustomTag } from '@vue3/components';
import { computed, PropType } from 'vue';
import { downloadLinkFile, ESystemType } from '@core/api';
import {
  ETaxSourceType,
  ISettlementOrderDetail,
  ISettlementOrderDuty,
  paymentChannelLabel,
  settlementStatusLabel,
  settlementStatusStyle,
  proxyPayTypeConfig,
  invoiceTaxMethodConfig,
  serverCrowdCreditCode,
} from '@core/main/types';
import { useUserStore } from '@core/main';

const { state: userState } = useUserStore();

const props = defineProps({
  duty: {
    type: Object as PropType<ISettlementOrderDuty>,
    required: true,
  },
  info: {
    type: Object as PropType<ISettlementOrderDetail>,
    required: true,
  },
});

const orderStatus = computed(() => settlementStatusStyle[props.duty.orderStatus] as any);
const isServer = computed(() => userState.identity?.systemType === ESystemType.Server);
const isHnFreePartners = computed(() => serverCrowdCreditCode?.includes(userState.identity?.serverDTO?.creditCode) && isServer.value);

async function openLinkFile(url: string) {
  try {
    await downloadLinkFile(url);
    ElMessage.success('下载成功');
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}
</script>

<style lang="scss" scoped src="./index.scss" />
